import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { HourMeasurementDetailsList } from "./HourMeasurementDetails/HourMeasurementDetailsList";
import { DeviceList } from "./DeviceList";
import { TimeMarkList } from "./TimeMarkList";

export function DetailedHourInfoSection() {

    const { deviceId, date, hour, timeMark } = useAppSelector(state => state.weatherStationsService)

    return (
        <div className="detailed-hour-info-section-div">
            <DeviceList />
            {!!deviceId && hour != null && !!date && <TimeMarkList />}
            {!!deviceId && !!timeMark && <HourMeasurementDetailsList />}
        </div>
    )
}
